import { createSelector } from "reselect";

const companies = (state) => state.administration.companies;

export const loading = createSelector(companies, (state) => state.loading);

export const loadingAction = createSelector(
  companies,
  (state) => state.loadingAction
);

export const data = createSelector(companies, (state) => state.data);

export const pagination = createSelector(
  companies,
  (state) => state.pagination
);

export const detail = createSelector(companies, (state) => state.detail);
